import { useAuth } from "@/lib/AuthContext";
import { Card } from "@/components/ui/card";
import { Lock, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isPaidTier } from "@/lib/membershipUtils";

export default function MembershipGate({ children }) {
  const { user } = useAuth();

  if (!isPaidTier(user?.membership_type)) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="p-10 border-0 shadow-lg text-center max-w-md w-full mx-auto">
          <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
            <Lock className="w-8 h-8 text-primary" />
          </div>
          <h2 className="text-2xl font-display font-bold mb-2">Members Only</h2>
          <p className="text-muted-foreground mb-6">
            Upgrade to <span className="text-sky-400 font-semibold">Momentum</span>,{" "}
            <span className="text-orange-400 font-semibold">Strength</span>, or{" "}
            <span className="text-amber-300 font-semibold">Elite Coaching</span> to access this feature.
          </p>
          <div className="grid grid-cols-3 gap-3 mb-6">
            <div className="p-4 rounded-xl border bg-muted/50 text-left">
              <p className="font-bold text-sm mb-1 text-sky-400">Momentum</p>
              <p className="text-xs text-muted-foreground">Workouts &amp; tracking</p>
            </div>
            <div className="p-4 rounded-xl border bg-muted/50 text-left">
              <p className="font-bold text-sm mb-1 text-orange-400">Strength</p>
              <p className="text-xs text-muted-foreground">Plans &amp; nutrition</p>
            </div>
            <div className="p-4 rounded-xl border border-amber-400/30 bg-amber-400/5 text-left relative overflow-hidden">
              <div className="absolute top-1 right-1">
                <Zap className="w-3 h-3 text-amber-300" />
              </div>
              <p className="font-bold text-sm mb-1 text-amber-300">Elite Coaching</p>
              <p className="text-xs text-muted-foreground">1:1 with a coach</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground">
            Contact your trainer or admin to upgrade your membership.
          </p>
        </Card>
      </div>
    );
  }

  return children;
}
